export default __webpack_public_path__ + "static/media/total_participants_icon.06e9e974.svg";